import React from 'react';
import PropTypes from 'prop-types';
import SubmissionFooter from 'screens/Integrations/components/SubmissionFooter';
import { CalAgContext } from '../../context/Provider';

const CalAgSubmissionFooter = ({
  nextDisabled,
  nextLabel,
  onNext,
  loading,
  setModalSubmissionState,
  isLastStep,
  displaySubmissionModal
}) => {
  return (
    <SubmissionFooter
      nextDisabled={nextDisabled}
      onNext={onNext}
      nextLabel={nextLabel}
      loading={loading}
      setModalSubmissionState={setModalSubmissionState}
      isLastStep={isLastStep}
      context={CalAgContext}
      displaySubmissionModal={displaySubmissionModal}
      integrationType="CalAgPermits"
    />
  );
};

CalAgSubmissionFooter.propTypes = {
  nextDisabled: PropTypes.bool,
  nextLabel: PropTypes.string,
  loading: PropTypes.bool,
  onNext: PropTypes.func,
  setModalSubmissionState: PropTypes.func,
  isLastStep: PropTypes.bool,
  displaySubmissionModal: PropTypes.bool
};

CalAgSubmissionFooter.defaultProps = {
  nextDisabled: false,
  nextLabel: 'Next',
  loading: false,
  onNext: () => {},
  setModalSubmissionState: () => {},
  isLastStep: false,
  displaySubmissionModal: true
};

export default CalAgSubmissionFooter;
